// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"wo-z","selected":"xo-z"};